<template>
  <div class="home">
    <Header></Header>
    <div class="container">
      <div class="row mt-5 mb-5">
        <div class='col-12'>
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'

export default {
  name: 'Home',
  mounted() {
    window.location = 'https://onlineada.com/certification/'
  },
  components: {
    Header
  }
}
</script>
